import { useEffect, useSyncExternalStore } from 'react';
import type { Store } from './store';

/**
 * Subscribe a component to an external store. `subscribe`/`getSnapshot` are
 * stable identities created by `createStore`, so React can diff safely.
 */
export function useStore<T extends object>(store: Store<T>): T {
  return useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot);
}

/**
 * The project bans `useEffect` (see AGENTS.md: "no-use-effect"). This wrapper is
 * the single sanctioned escape hatch, for one-time synchronization with an
 * external system on mount — global event listeners, third-party widgets, and
 * the like. Anything else should be derived state, an event handler, or `key`.
 */
export function useMountEffect(effect: () => void | (() => void)): void {
  // eslint-disable-next-line no-restricted-syntax
  useEffect(effect, []);
}
